/*
 * File: /src/services/leadStatusService.js
 * Created Date: Thursday November 4th 2021
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Tuesday, 14th December 2021 3:47:03 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2021 AdBase, Inc.
 */

import { authedAxios } from '../shared/axiosWrapper';
import { AD_BASE_LEAD_STATUS_PATH } from '../constants';

export default {
  fetchAll() {
    return authedAxios.get(AD_BASE_LEAD_STATUS_PATH);
  },
  fetchById(id) {
    return authedAxios.get(AD_BASE_LEAD_STATUS_PATH + id);
  },

  updateLeadStatus(id, payload) {
    return authedAxios.put(AD_BASE_LEAD_STATUS_PATH + id, payload);
  },

  createLeadStatus(payload) {
    return authedAxios.post(AD_BASE_LEAD_STATUS_PATH, payload);
  },
};
